export const phoneNumberNoFormatting = (number: string) => number.replace(/[^0-9]/g, '');

export const removePasswordOfCompanyLeadObject = (companyLead: any) => {
  return {
    first_name: companyLead.firstName || companyLead.first_name,
    last_name: companyLead.lastName || companyLead.last_name,
    email: companyLead.email,
    company_name: companyLead.companyName || companyLead.company_name,
    number_employees: companyLead.numberEmployees || companyLead.number_employees,
    phone: companyLead.phone ? phoneNumberNoFormatting(companyLead.phone) : undefined,
    submitted_from: companyLead?.submitted_from,
    sold_by: companyLead?.sold_by,
    sold_by_accountant_id: companyLead?.sold_by_accountant_id,
    campaign: companyLead?.campaign,
    industry: companyLead?.industry,
    lead_origin: companyLead.lead_origin,
    lead_origin_subtype: companyLead.lead_origin_subtype,
  };
};
